module.exports = __webpack_public_path__ + "cf7cc7760001ec3920710e82c0a29dec.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/4_column_xlarge_x1_variable/public/news/hw4blog.jpg
// module id = 470
// module chunks = 0